// Module
var code = "<div class=\"no-result\"> <div> <div> <h3 class=\"text-muted\" translate>list.no-results</h3> <p class=\"text-muted\" translate>query.click-on-refresh</p> </div> </div> </div> ";
// Exports
export default code;